// "Go to end" button. Sprint chatgpt-message-rail (D7) retired the old
// "appears only when new messages arrived" pill in favor of Santi's
// 2026-09-10 ask: visible whenever the founder is not at the bottom of
// the conversation, with the message counter shown only when unseen
// messages also exist. Two shapes, same element/testid: WITH a counter
// (icon + "N mensajes nuevos", as before) and WITHOUT one (icon-only
// circle, EC-9 — a case Santi asked for but never saw the shape of).
//
// Render rule: `visible || count > 0` — the `count > 0` branch with
// `visible === false` is a one-frame window between the counter bump and
// the next scroll event (EC-10); kept for compatibility.

import { useTranslation } from '../i18n';
import { Icon } from './atoms/Icon';

export interface ScrollToBottomPillProps {
  count: number;
  visible: boolean;
  onClick: () => void;
}

export function ScrollToBottomPill({ count, visible, onClick }: ScrollToBottomPillProps) {
  const { t } = useTranslation();
  if (!visible && count <= 0) return null;

  if (count > 0) {
    return (
      <button
        type="button"
        onClick={onClick}
        data-testid="scroll-to-bottom"
        className="absolute left-1/2 -translate-x-1/2 bottom-4 z-10 px-3 py-1.5 rounded-full bg-action text-action-foreground text-caption font-medium shadow-lg hover:bg-action/90 focus:outline-none focus:ring-2 focus:ring-action inline-flex items-center gap-1.5"
        aria-label={t('scrollToBottom.label')}
      >
        <Icon name="ArrowDown" size={12} aria-hidden="true" />
        <span>
          {count === 1
            ? t('scrollToBottom.newMessage', { count })
            : t('scrollToBottom.newMessages', { count })}
        </span>
      </button>
    );
  }

  // EC-9 — no counter: an icon-only circular button, same colour and
  // position as the counted form.
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="scroll-to-bottom"
      className="absolute left-1/2 -translate-x-1/2 bottom-4 z-10 p-2 rounded-full bg-action text-action-foreground shadow-lg hover:bg-action/90 focus:outline-none focus:ring-2 focus:ring-action inline-flex items-center justify-center"
      aria-label={t('scrollToBottom.label')}
    >
      <Icon name="ArrowDown" size={12} aria-hidden="true" />
    </button>
  );
}
